import { ModalSupportFooter } from "@jidlomat/terminal-ui/components/global/modals/ModalSupportFooter";
import { ModalContentWrapper } from "@jidlomat/terminal-ui/components/primitives/ModalContentWrapper";
import { ModalTitle } from "@jidlomat/terminal-ui/components/primitives/ModalTitle";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ErrorModalImage from "../../../../assets/illustrations/errorModalImage.svg";

type ErrorModalContentProps = {
	fridgeId: string;
	/** Already-translated title; defaults to `t("modals.error.title")`. */
	title?: string;
	/** Already-translated body; defaults to `t("modals.error.body")`. */
	body?: string;
};

export const ErrorModalContent = ({ fridgeId, title, body }: ErrorModalContentProps) => {
	const { t } = useTranslation();
	return (
		<ModalContentWrapper>
			<ModalTitle variant="promoHeader">{title ?? t("modals.error.title")}</ModalTitle>
			<Typography variant="promoText" mb={5}>
				{body ?? t("modals.error.body")}
			</Typography>
			<ErrorModalImage />
			<ModalSupportFooter fridgeId={fridgeId} />
		</ModalContentWrapper>
	);
};
